import { RatingField } from "@/components/Form/RHF/FormFields/RatingField/ratingField.component";
import { NumberIcon } from "@/components/Form/RHF/FormFields/RatingField/visuals/numberIcon";
import { TextAreaField } from "@/components/Form/RHF/FormFields/TextAreaField/textAreaField.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { WriteProgressiveReviewFormValues } from "../writeReview.schema";

type HuboPartialProps = { disabled?: boolean };

const HuboPartial = ({ disabled }: HuboPartialProps) => {
    const { t } = useGranite();

    return (
        <>
            <Row>
                <Col>
                    <RatingField<WriteProgressiveReviewFormValues>
                        name="brandScore"
                        required={false}
                        label={t("product.reviews.form.brandScore.label")}
                        disabled={disabled}
                        min={0}
                        max={10}
                    >
                        {NumberIcon}
                    </RatingField>
                </Col>
            </Row>
            <Row>
                <Col>
                    <TextAreaField<WriteProgressiveReviewFormValues>
                        name="brandComment"
                        label={t("product.reviews.form.brandComment.label")}
                        required={false}
                        placeholder={t(
                            "product.reviews.form.brandComment.placeholder"
                        )}
                        maxLength={5000}
                        disabled={disabled}
                    />
                </Col>
            </Row>
        </>
    );
};

export { HuboPartial };
